<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import apiClient from "@/apiClient";
import TimeAgo from "@/components/TimeAgo.vue";
import { useBreadcrumbs } from "@/composables/useBreadcrumbs";

useBreadcrumbs().setBreadcrumb("Activity Feed");

const activities = ref([]);
const loading = ref(false);

const loadFeed = async () => {
  loading.value = true;
  try {
    const response = await apiClient.get("/api/activity/feed?limit=200");
    activities.value = response.data || [];
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  loadFeed();
});

onUnmounted(() => {

});
</script>

<template>
  <div class="space-y-6">
    <div class="flex flex-wrap items-center justify-between gap-3">
      <div>
        <h1 class="text-2xl font-semibold text-slate-900 dark:text-slate-100">Activity Feed</h1>
      </div>
      <button class="btn accent h-9 px-4" type="button" @click="loadFeed">
        Refresh
      </button>
    </div>

    <div class="rounded-xl border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800">
      <div v-if="loading" class="px-6 py-6 text-sm text-slate-500 dark:text-slate-300">
        Loading activity...
      </div>
      <div v-else-if="!activities.length" class="px-6 py-6 text-sm text-slate-500 dark:text-slate-300">
        No recent activity.
      </div>
      <ul v-else class="divide-y divide-slate-200 dark:divide-slate-700">
        <li v-for="entry in activities" :key="entry.id" class="px-6 py-4">
          <div class="flex flex-wrap items-center gap-3">
            <div class="flex items-center gap-3">
              <div
                class="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-slate-100 text-sm font-semibold text-slate-600 dark:bg-slate-700 dark:text-slate-200"
              >
                <img v-if="entry.user?.avatar_url" :src="entry.user.avatar_url" :alt="entry.user?.name"
                  class="h-full w-full object-cover" />
                <span v-else>{{ entry.user?.name?.[0] ?? "?" }}</span>
              </div>
              <div>
                <div class="text-sm font-semibold text-slate-900 dark:text-slate-100">
                  {{ entry.user?.name ?? "Unknown User" }}
                </div>
                <div class="text-xs text-slate-500 dark:text-slate-300">
                  <TimeAgo :data="entry.created_at" />
                </div>
              </div>
            </div>
            <div class="text-sm text-slate-700 dark:text-slate-200">
              {{ entry.message }}
            </div>
          </div>
          <div v-if="entry.path" class="mt-2 text-xs text-slate-400">
            {{ entry.path }}
          </div>
          <div v-if="entry.summary" class="mt-2 text-sm text-slate-600 dark:text-slate-300">
            "{{ entry.summary }}"
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
